import {AbsenceRequest} from './AbsenceRequest';

export class HrAdminAbsenceRequest extends AbsenceRequest {
    isCompleted: number;

    constructor(absenceRequest: AbsenceRequest) {
        super(absenceRequest.id, absenceRequest.employeeId, absenceRequest.absenceDay, absenceRequest.absenceTypeId,
              absenceRequest.absenceStartDate, absenceRequest.absenceEndDate, absenceRequest.description, absenceRequest.filePath,
              absenceRequest.freeDayAmount, absenceRequest.readAndAprroved, absenceRequest.absenceExcuseReasonId,
              absenceRequest.fileList, absenceRequest.proxyManagerId);
    }
}
